
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.545 8.511v-.193c.004-.663.063-1.191.177-1.585.117-.394.287-.712.511-.955.223-.242.492-.462.807-.659.235-.151.445-.308.63-.471.186-.163.334-.343.444-.54.11-.2.164-.424.164-.67 0-.262-.062-.491-.187-.688a1.248 1.248 0 00-.506-.455 1.506 1.506 0 00-.693-.159c-.246 0-.48.055-.699.165-.22.106-.4.265-.54.477-.14.209-.216.468-.227.779H.108c.019-.758.2-1.383.545-1.875A3.124 3.124 0 012.023.574a4.68 4.68 0 011.88-.37c.754 0 1.42.126 2 .376.58.246 1.035.604 1.364 1.073.33.47.494 1.036.494 1.7 0 .442-.074.836-.221 1.181a2.88 2.88 0 01-.608.91 4.71 4.71 0 01-.926.71c-.3.177-.546.363-.739.556-.19.193-.331.417-.426.67a2.89 2.89 0 00-.142.938v.193H2.545zm1.125 3.637c-.378 0-.702-.133-.971-.398a1.307 1.307 0 01-.392-.966c-.004-.371.127-.69.392-.954.269-.266.593-.398.971-.398.36 0 .677.132.95.398a1.304 1.304 0 01.215 1.642 1.47 1.47 0 01-.494.494 1.291 1.291 0 01-.67.182z","fill":"#ABAFB5"}})])
          )
        }
      }
    